import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment.prod';
import { LoginService } from '../services/login.service';
import { DashboardService } from '../services/dashboard.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit {

  LoginImg = "A";
  _Langname = "";
  _css = "";
  _dir = "";
  StockNotifications: any[];
  Locations: any[];
  _LocationName: string = "Select Location";
  _flagar = true;
  _flagen = true;
  constructor(
    public api: LoginService,
    public apiDashboard: DashboardService,
    private translateService: TranslateService,
    private router: Router
  ) {
    this.api.CheckUserAuthentication(environment.rootScope);
    translateService.use(environment.Language);

    this.LoginImg = environment.rootScope.User.FirstName;
    this._LocationName = environment.LocationSelected.Name;
    var body = document.body;

    this.GetALLlocations(environment.rootScope.Locations);
    this.GetNotifications();
    if (environment.Language == "en") {
      this._Langname = "English";
      this._css = "flag-icon flag-icon-us";
      this._dir = "ltr";
      body.classList.add("body-font");
      this._flagen = false;
    }
    else {
      this._Langname = "عربى";
      this._css = "flag-icon flag-icon-sa";
      this._dir = "rtl";
      body.classList.add("body-font-arabic");
      this._flagar = false;
    }

  }

  ngOnInit() {

  }

  switchLanguage(language: string) {
    environment.Language = language;
    environment.dir = language == "en" ? "ltr" : "rtl";
    localStorage.setItem('_Language', language);
    localStorage.setItem('_dir', environment.dir);
    window.location.reload();

  }
  Logout() {
    this.api.Logout();
  }
  Profile() {
    
    if (environment.rootScope.IsSubuser == true) {
      this.router.navigate(["company/user/edit-users",environment.rootScope.User.UserID]);
    }
    else{
      this.router.navigate(['/company/detail']);
    }
  }

  GetALLlocations(data) {
    this.Locations = data;
    // this.apiDashboard.GetALLlocations(environment.rootScope.SuperUserID)
    //   .subscribe((data: any) => {

    //     this.Locations = data;

    //   },
    //     (err: HttpErrorResponse) => {

    //       console.log(err)
    //     });
  }
  GetNotifications() {
    this.apiDashboard.GetStockNotification(environment.LocationSelected.LocationID)
      .subscribe((data: any) => {
        this.StockNotifications = data;
      },
        (err: HttpErrorResponse) => {
          console.log(err)
        });
  }
  changeloc(LocObj) {
    environment.LocationSelected = LocObj;
    localStorage.setItem('token', LocObj.Session);
    sessionStorage.setItem('rootScopeLocation', JSON.stringify(environment.LocationSelected));
    this._LocationName = LocObj.Name;
    window.location.reload();
  }
}
